// hooks
import useAuth from '../hooks/useAuth';
//
import { MAvatar } from './@material-extend';
import createAvatar from '../utils/createAvatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  const { user } = useAuth();

  return (
    <MAvatar
      src={user?.photoUrl ?? null}
      alt={user?.superAdmin?.name}
      color={createAvatar(user?.superAdmin?.name).color}
      {...other}
    >
      {createAvatar(user?.superAdmin?.name).name}
    </MAvatar>
  );
}
